<script>
/**
 * @overview 场景管理 - 入口
 *
 * @author  huojinzhao
 */

export default {
  name: "ViewTheme",
};
</script>

<template>
  <div class="layout-screen view-theme">
    <TheHeader />

    <router-view />
  </div>
</template>

<style lang="postcss">
.view-theme {
  display: flex;
  flex-direction: column;
}
</style>
